import { jsxs as m, jsx as l } from "react/jsx-runtime";
import p from "react";
import { classes as d } from "../../utils/styles.js";
import e from "./icon.module.js";
const y = ({
  svgIcon: r,
  textIcon: s,
  label: a,
  color: i,
  textColor: o,
  displayText: c,
  className: n
}) => {
  const t = s ? s.slice(0, 2).toUpperCase() : "";
  return /* @__PURE__ */ m("div", { className: d([e.iconWrapper, n ?? ""]), children: [
    /* @__PURE__ */ l(
      "div",
      {
        className: e.iconContainer,
        "aria-label": a,
        role: "img",
        style: { backgroundColor: r ? "transparent" : i },
        children: r ? p.cloneElement(r) : s ? /* @__PURE__ */ l("div", { className: e.textIcon, style: { color: o }, children: t }) : null
      }
    ),
    c && /* @__PURE__ */ l("span", { className: e.labelText, "aria-hidden": !0, children: a })
  ] });
};
export {
  y as AccessibleIcon
};
